// stores/useDialogStore.js
import { create } from "zustand";

const useDialogStore = create((set, get) => ({
  isOpen: false,
  title: "",
  content: null,

  openDialog: ({ title, content }) =>
    set({
      isOpen: true,
      title,
      content,
    }),

  closeDialog: () =>
    set({
      isOpen: false,
      title: "",
      content: null,
    }),

  getIsOpen: () => get().isOpen,
}));

export default useDialogStore;
